import { connect } from 'react-redux';

import { selectHomeOwnerAddress } from '@/store/reducers/shipping-addreses/selectors';
import { AppState, ContactVm } from '@/types';

import { ShippingDetails as Component } from './ShippingDetails';

const mapStateToProps = (state: AppState) => ({
  homeownerAddress: selectHomeOwnerAddress(state) as ContactVm,
});

export const ShippingDetails = connect(mapStateToProps)(Component);
